import React from "react";
import Image from "next/image";

const Gallerymodal = ({ clickedImage, handleRotationRight, setClickedImage }) => {
    const handleClick = (e) => {
        if (e.target.classList.contains("dismiss")) {
            setClickedImage(null)
        }
    }
    return (
        <>
            <div className="modal_overlay dismiss" onClick={handleClick}>
                <img className="modal_image" src={clickedImage} alt="biger pcture" />
                <span className="dismiss close_icon" onClick={handleClick}><Image src='/icons/close-white.svg' className="dismiss" onClick={handleClick} width={20} height={20} alt='Close arrow'></Image></span>
                <div onClick={handleRotationRight} className="overlay-arrows_left"><Image src='/icons/left-white.svg' width={30} height={30} alt='Left Icon'></Image></div>
                <div onClick={handleRotationRight} className="overlay-arrows_right"><Image src='/icons/right-white.svg' width={30} height={30} alt='Right Icon'></Image></div>
            </div>
        </>
    )
}

export default Gallerymodal;
